import { render } from "./VacancyIndex.vue?vue&type=template&id=55abed35&scoped=true"
import script from "./VacancyIndex.vue?vue&type=script&lang=js"
export * from "./VacancyIndex.vue?vue&type=script&lang=js"

import "./VacancyIndex.vue?vue&type=style&index=0&id=55abed35&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55abed35"]])

export default __exports__